import {
    pageList,
    batchDeleteTask,
    getTaskCenterData,
    editTaskCenter,
    goodsFissionRetry,
    aiTaskItems,
    aiTaskItemRetry,
} from '@api/prod/center/taskCenter.js';

export const pageListApi = (data) => {
  return pageList(data).then((res) => {
      if (res.result === 1) {
          return res.data;
      }
      return false;
  })
}
export const batchDeleteTaskApi = (data) => {
  return batchDeleteTask(data).then((res) => {
      if (res.result === 1) {
          return true;
      }
      return false;
  })
}
export const getTaskCenterDataApi = (data) => {
  return getTaskCenterData(data).then((res) => {
      if (res.result === 1) {
          return res.data;
      }
      return false;
  })
}
export const editTaskCenterApi = (data) => {
  return editTaskCenter(data).then((res) => {
      if (res.result === 1) {
          return true;
      }
      return false;
  })
}
export const goodsFissionRetryApi = (data) => {
  return goodsFissionRetry(data).then((res) => {
      if (res.result === 1) {
          return true;
      }
      return false;
  })
}
export const aiTaskItemsApi = (data) => {
  return aiTaskItems(data).then((res) => {
      if (res.result === 1) {
          return res?.data || [];
      }
      return [];
  })
}
export const aiTaskItemRetryApi = (data) => {
  return aiTaskItemRetry(data).then((res) => {
      if (res.result === 1) {
          return true;
      }
      return false;
  })
}